module.exports = __webpack_public_path__ + "e86bfbae0376dd3b230cf4001f6b7f55.svg";